import React from 'react'
import { Input } from '../ui/input'

// Al editar, el deporte ya no se elige: la base no deja cambiarlo (20261002, R2).
const DeporteFijo = ({ nombre, crea, id }) => (
  <>
    <Input id={id} value={nombre} readOnly disabled />
    <p className="mt-1 text-xs text-muted-foreground">
      {`El deporte se elige al crear y no se cambia. Para otro deporte, crea ${crea}.`}
    </p>
  </>
)

export default DeporteFijo
